export default __webpack_public_path__ + "static/media/security02.48440b58.png";